export interface BusinessConfig {
  business: { name: string };
  contacts: {
    whatsapp: { display: string; e164: string; url: string };
    telephone: { display: string; e164: string; url: string };
    email: { display: string; url: string };
    website: { display: string; url: string };
  };
  contact_order: ['whatsapp', 'telephone', 'email', 'website'];
  trust_messages: string[];
  service_messages: string[];
  coverage: { summary: string; named_areas: string[] };
  prohibited_content: string[];
  environments: Record<'staging' | 'production', { public_card_url: string }>;
}

export const businessConfig = {
  "business": {
    "name": "Greenwood Autocare"
  },
  "contacts": {
    "whatsapp": {
      "display": "+44 7716 392212",
      "e164": "+447716392212",
      "url": "https://wa.me/447716392212"
    },
    "telephone": {
      "display": "01789 335 844",
      "e164": "+441789335844",
      "url": "tel:+441789335844"
    },
    "email": {
      "display": "service@greenwoodautocare.co.uk",
      "url": "mailto:service@greenwoodautocare.co.uk"
    },
    "website": {
      "display": "www.greenwoodautocare.co.uk",
      "url": "https://www.greenwoodautocare.co.uk"
    }
  },
  "contact_order": [
    "whatsapp",
    "telephone",
    "email",
    "website"
  ],
  "trust_messages": [
    "Trusted",
    "Expert Service",
    "Convenient",
    "Local Business"
  ],
  "service_messages": [
    "Reliable & Professional",
    "Diagnostics",
    "Servicing & Repairs",
    "Mobile Service"
  ],
  "coverage": {
    "summary": "Covering Pebworth, Long Marston, Meon Vale, and surrounding areas",
    "named_areas": [
      "Pebworth",
      "Long Marston",
      "Meon Vale",
      "Surrounding areas"
    ]
  },
  "prohibited_content": [
    "VAT number",
    "MOBILE VEHICLE SERVICE strapline"
  ],
  "environments": {
    "staging": {
      "public_card_url": "https://card-staging.greenwoodautocare.co.uk/"
    },
    "production": {
      "public_card_url": "https://card.greenwoodautocare.co.uk/"
    }
  }
} as const satisfies BusinessConfig;
